// @flow

import * as React from 'react';

import { connect } from 'react-redux';

import {
  fetchCountryList as fetchCountryListBase,
  type FetchCountryListAction,
  selectIsFetchingCountryList,
  selectIsFailureCountryList,
  selectIsLoadedCountryList,
  selectIsToRefetchCountryList,
  type FullState,
} from '@gandi/redux-places';

import type { PreFetchArgs } from '../types';

type DispatchProps = {
  fetchCountryList: FetchCountryListAction,
};

type StateProps = {
  isFetching: boolean,
  isLoaded: boolean,
  isToRefetch: boolean,
  isFailure: boolean,
};

type Props = {
  ...StateProps,
  ...DispatchProps,
};

const CountryLoader = ({
  fetchCountryList,
  isFetching,
  isLoaded,
  isToRefetch,
  isFailure,
}: Props) => {
  const shouldFetch = !isFetching && (isToRefetch || (!isLoaded && !isFailure));

  React.useEffect(() => {
    if (shouldFetch) {
      fetchCountryList();
    }
  }, [fetchCountryList, shouldFetch]);

  return null;
};

CountryLoader.preFetch = (props: PreFetchArgs<{}>) =>
  props.dispatch(fetchCountryListBase());

const mapStateToProps = (state: FullState): StateProps => ({
  isFailure: selectIsFailureCountryList(state),
  isFetching: selectIsFetchingCountryList(state),
  isLoaded: selectIsLoadedCountryList(state),
  isToRefetch: selectIsToRefetchCountryList(state),
});

const mapDispatchToProps: DispatchProps = {
  fetchCountryList: fetchCountryListBase,
};

// $FlowFixMe[signature-verification-failure]
// $FlowFixMe[underconstrained-implicit-instantiation]
export default connect(mapStateToProps, mapDispatchToProps)(CountryLoader);
